import { LineSeriesOption } from 'echarts/charts';
import { TimeSeriesValueTuple } from '../../core';
import { LegendItem } from '../Legend';

export interface GraphSeries {
  name: string;
  values: TimeSeriesValueTuple[];
  id?: string;
}

export type EChartsValues = number | null | '-';

export interface LegacyTimeSeries extends Omit<LineSeriesOption, 'data'> {
  data: EChartsValues[];
}

export type TimeChartLegendItems = LegendItem[];

// [DEPRECATED] used for legacy LineChart 'category' axis.
// May delete in future when embed users migrate to TimeChart.
export type EChartsDataFormat = {
  timeSeries: LegacyTimeSeries[];
  xAxis: number[];
  legendItems?: LegendItem[];
  xAxisMax?: number | string;
  rangeMs?: number;
};

// Intentionally making this an object to start because it is plausible we will
// want to support focusing by other attributes (e.g. index, name) in the future,
// and starting with an object will make adding them a non-breaking change.
export type ChartInstanceFocusOpts = {
  id?: string; // LineChart uses id
  name?: string; // TimeChart uses name
};

export type ChartInstance = {
  /**
   * Highlight the series associated with the specified options.
   */
  highlightSeries: (opts: ChartInstanceFocusOpts) => void;

  /**
   * Clear all highlighted series.
   */
  clearHighlightedSeries: () => void;
};

export const PINNED_CROSSHAIR_SERIES_NAME = 'Pinned Crosshair';

export const DEFAULT_PINNED_CROSSHAIR: LineSeriesOption = {
  name: PINNED_CROSSHAIR_SERIES_NAME,
  type: 'line',
  data: [],
  lineStyle: {
    width: 0, // should be hidden at all times since this is the line series that markline is attached to for pinned crosshair
  },
  // https://echarts.apache.org/en/option.html#series-line.markLine
  markLine: {
    data: [],
    lineStyle: {
      type: 'dashed',
      width: 2,
    },
    emphasis: {
      lineStyle: {
        width: 2,
        opacity: 1,
      },
    },
    blur: {
      lineStyle: {
        width: 2,
        opacity: 1,
      },
    },
    silent: true, // set it to true so markline label does not show on hover, but this disables all mouse events for the markline
  },
};

export interface DatapointInfo {
  dataIndex: number;
  seriesIndex: number;
  seriesName: string;
  yValue: number;
}

export const EVENT_ICON_Y = 1;
